namespace TabAurous.Administration {
    export interface PushNotifyConfigForm {
        AppId: Serenity.StringEditor;
        ApiKey: Serenity.StringEditor;
    }

    export class PushNotifyConfigForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PushNotifyConfig';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PushNotifyConfigForm.init)  {
                PushNotifyConfigForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PushNotifyConfigForm, [
                    'AppId', w0,
                    'ApiKey', w0
                ]);
            }
        }
    }
}
